import React from 'react';
import './App.css';
import Redirector from './Redirector';
import { Routes, Route } from 'react-router-dom';
import DownloadRedirector from './DownloadRedirector';

function App() {
  return (
    <Routes>
      <Route path="/store/*" element={<DownloadRedirector />} />
      <Route path="/joinbeta/*" element={<DownloadRedirector />} />
      <Route path="/get/*" element={<DownloadRedirector />} />
      <Route path="/*" element={<Redirector />} />
    </Routes>
  );
}

export default App;
